import { cn } from 'cn';
import { isValidElement, type ReactNode } from 'react';

export type KeyInformationItem = {
  readonly label: string;
  readonly value?: ReactNode;
} & ComponentStyling;

type P = {
  readonly hasDivider?: boolean;
  readonly hasHighContrast?: boolean;
  readonly valueSize?: 'default' | 'large';
} & KeyInformationItem;

export const KeyInformation = ({
  className,
  hasDivider = false,
  hasHighContrast = false,
  label,
  style,
  value,
  valueSize = 'default',
}: P) => (
  <div
    key={label}
    className={cn(
      'relative flex min-w-0 shrink flex-col items-center py-4',
      className,
    )}
    style={style}
    title={
      ['string', 'number'].includes(typeof value)
        ? `${label}: ${String(value)}`
        : undefined
    }
  >
    <span
      className={cn(
        'w-full max-w-full text-center leading-8 text-tiga-text-default',
        {
          'text-base': valueSize === 'default',
          'text-2xl': valueSize === 'large',
          'overflow-hidden text-ellipsis whitespace-nowrap':
            !isValidElement(value), // truncate text, but not React elements
        },
      )}
    >
      {value ?? <span className="text-tiga-text-lightest">—</span>}
    </span>

    <label
      className={cn(
        'w-full max-w-full overflow-hidden text-center text-xs text-ellipsis whitespace-nowrap',
        hasHighContrast ? 'text-tiga-text-default' : 'text-tiga-text-lighter',
      )}
    >
      {label}
    </label>
    {hasDivider ? (
      <div
        className="absolute top-3 bottom-3 -left-4 z-10 w-0 border-l border-tiga-border-default"
        data-key-information-divider
      />
    ) : null}
  </div>
);
